import React from 'react';

const PenpalContextBuccal = React.createContext(null);

export default PenpalContextBuccal;
